import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

const IconBoxCard = dynamic(() =>
  import("@/components/common/card/IconBoxCard")
);

const TwoColumnGradientCard = (props) => {
  const { externalLinkPage, labelsList } = props;

  const [standardPage, setStandardPage] = useState();
  const { siteConfig } = useSelector((state) => {
    return {
      siteConfig: state?.labelsConfig?.labelsAndConfigData?.siteConfig,
    };
  });

  useEffect(() => {
    if (siteConfig?.subMenuList?.length > 0) {
      setStandardPage(siteConfig?.subMenuList?.[0]);
    }
  }, [siteConfig]);
  return (
    <>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
          {standardPage && (
            <div>
              <IconBoxCard
                bg={standardPage?.standardPageBackgroundImage?.[0].webp}
                alt={standardPage?.standardPageBackgroundImage?.[0].alt}
                imgTitle={standardPage?.standardPageBackgroundImage?.[0].title}
                icon={standardPage?.standardPageIcon?.webp}
                iconAlt={standardPage?.standardPageIcon?.alt}
                iconTitle={standardPage?.standardPageIcon?.Title}
                bgColor={"gradient-red"}
                title={standardPage?.standardPageSubtitle}
                info={standardPage?.standardPageAbstract}
                btnText={labelsList?.more}
                btnUrl={`/net/${standardPage?.slug}`}
              />
            </div>
          )}
          {externalLinkPage && (
            <div>
              <IconBoxCard
                bg={externalLinkPage?.pageWithExternallinkBackgroundImage?.webp}
                alt={externalLinkPage?.pageWithExternallinkBackgroundImage?.alt}
                imgTitle={
                  externalLinkPage?.pageWithExternallinkBackgroundImage?.title
                }
                bgColor="gradient-blue"
                icon={externalLinkPage?.pageWithExternallinkIcon?.webp}
                iconAlt={externalLinkPage?.pageWithExternallinkIcon?.alt}
                iconTitle={externalLinkPage?.pageWithExternallinkIcon?.Title}
                title={externalLinkPage?.pageWithExternallinkSubtitle}
                info={externalLinkPage?.pageWithExternallinkAbstract}
                btnText={labelsList?.englishTest}
                btnUrl={externalLinkPage?.link}
                target={"_blank"}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TwoColumnGradientCard;
